import { ChevronRight } from "lucide-react";
import "./ccSessions.css";

import stagePhoto from "../../../assets/elliot-conference.webp";

import nace from "../../../assets/NACE Badge.webp";
import eace from "../../../assets/EACE Badge.webp";
import vace from "../../../assets/VACE Badge.webp";
import scace from "../../../assets/SCACE Badge.webp";
import floridaAce from "../../../assets/FloridaACE Badge.webp";
import sunyCdo from "../../../assets/SUNY CDO Badge.webp";

const memberships = [
  { name: "NACE", src: nace },
  { name: "EACE", src: eace },
  { name: "VACE", src: vace },
  { name: "SCACE", src: scace },
  { name: "FloridaACE", src: floridaAce },
  { name: "SUNY CDO", src: sunyCdo },
];

const CcSessions = () => (
  <section className="cc-section cc-sessions">
    <div className="home-container">
      {/* Banner and membership strip are one card, so the badges read as part
          of the same claim rather than six circles adrift on white. */}
      <div className="cc-sessions-card">
        <div className="cc-sessions-banner">
          <img width={1536} height={1024} decoding="async" loading="lazy"
            src={stagePhoto}
            alt="A RAIN team member speaking at a career services conference session"
            className="cc-sessions-photo"
          />
          <span className="cc-sessions-scrim" aria-hidden="true" />

          <div className="cc-sessions-copy">
            <h2 className="cc-sessions-title">
              Every conference.
              <br />
              Every conversation.
            </h2>
            <p className="cc-sessions-sub">
              We&rsquo;re on the road with career services all year, and what we
              hear comes back to your office.
            </p>
            <a
              className="cc-sessions-btn"
              href="mailto:adminrain@raincareers.com"
            >
              Find us at the next one
              <ChevronRight size={16} strokeWidth={2.4} />
            </a>
          </div>
        </div>

        <div className="cc-sessions-strip">
          <p className="cc-sessions-note">
            Members and sponsors of the associations your team already belongs
            to.
          </p>

          <ul className="cc-sessions-badges">
            {memberships.map(({ name, src }) => (
              <li key={name}>
                <img decoding="async" src={src} alt={name} loading="lazy" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default CcSessions;
